var 
	Access,
	_body,
	_window
;

(function($){

	Access = {

		$ : false,
		$main : null,
		components : [],
		$closeLibras : [],
		$toggleContrast : null,
		$openLibras : null,
		$zoomIn : null,
		$zoomOut : null,
		$shortlinks : null,
		timeLibras : false,
		timeClose : false,

		init : function(){

			// Body
			if( _body === undefined ){
				_body = $( 'body' );
			} 

			// Window
			if( _window === undefined ){
				_window = $( window );
			}

			this.$main = $( 'body' );

			// Shortlinks
			this.$shortlinks = $( '#shortlinks a' );
			this.bindShortlinks();

			// Vlibras
			this.$openLibras = $( 'div[vw-access-button]' );
			this.$toggleLibras = $( 'button[data-action="toggle-vlibras"]', this.$ );
			this.$toggleLibras.on( 'click', '', function(){
				Access.toggleLibras();
			});

			// Zoom
			this.$zoomIn = $( '[data-action="zoom-in"]', this.$ );
			this.$zoomIn.on( 'click', function(e){
				e.preventDefault();
				Access.setZoom( 'more' );
			});
			this.$zoomOut = $( '[data-action="zoom-out"]', this.$ );
			this.$zoomOut.on( 'click', function(e){
				e.preventDefault();
				Access.setZoom( 'less' );
			});

			// Dark mode
			this.$sheetDarkMode = $( 'link#sheet-dark-mode' );
			this.$darkmode = $( 'button[data-action="toggle-dark-mode"]', this.$ );
			this.$darkmodeLabel = $( 'strong', this.$darkmode );
			this.lightModeTitle = this.$darkmodeLabel.first().text();
			this.darkModeTitle = this.$darkmode.first().data( 'active-title' );
			this.$darkmode.on( 'click', function(e){
				e.preventDefault();
				Access.toggleDarkMode();
			});
			if( this.$sheetDarkMode.prop( 'disabled' ) === false ){
				Access.enableDarkMode();
			}

			// Contrast
			this.$sheetContrast = $( 'link#sheet-alto-contraste' );
			this.$contrast = $( 'button[data-action="toggle-contrast"]', this.$ );
			this.$contrast.on( 'click', function(e){
				e.preventDefault();
				Access.toggleContrast();
			});
			if( this.$sheetContrast.prop( 'disabled' ) === false ){
				Access.enableContrast();
			}

		},

		bindShortlinks : function(){

			this.$shortlinks.on( 'click', function(){

				this.$ = this.$ || $( this );

				const action = this.$.data( 'action' );
				if( action === 'open-menu' || action === 'open-search' ){
					Header.openFloater();
				}
				if( action === 'open-menu' ){
					$( '.menu-suspenso .categs-controls a' ).first().focus();
				}
				else if( action === 'open-search' ){
					$( '.menu-suspenso .search-box button[data-action="open-search"]' ).click();
				}				

			});

		},

		setZoom : function( action ){

			var zoom = parseInt( this.$main.css( 'font-size' ) );

			if( action == 'more' && zoom < 14 ){
				zoom += 2;
			}
			else if( action == 'less' && zoom > 10 ){
				zoom -= 2;
			}

			// Enable and disable
			this.$zoomIn.prop( 'disabled', ( zoom >= 14 ? true : false ) );
			this.$zoomOut.prop( 'disabled', ( zoom <= 10 ? true : false ) );
			
			// Set zoom
			this.$main.css( 'font-size', zoom + 'px' );

		},

		// Toggle hight contrast
		toggleContrast : function(){
			if( Access.$contrast.hasClass( 'active' ) ){
				Access.disableContrast();
			}
			else {
				Access.enableContrast();
			}
		},
		enableContrast : function(){
			Cookie.set( 'alto-contraste', 'true' );
			Access.$sheetContrast.prop( 'disabled', false );
			Access.$contrast.addClass( 'active' );
		},
		disableContrast : function(){
			Cookie.set( 'alto-contraste', 'false' );
			Access.$sheetContrast.prop( 'disabled', true );
			Access.$contrast.removeClass( 'active' );
		},

		// Toggle dark mode
		toggleDarkMode : function(){

			Access.disableContrast();
			
			if( Access.$darkmode.hasClass( 'active' ) ){
				Access.disableDarkMode();
			}
			else {
				Access.enableDarkMode();
			}
		
		},
		enableDarkMode : function(){
			Cookie.set( 'dark-mode', 'true' );
			Access.$sheetDarkMode.prop( 'disabled', false );
			Access.$darkmode.addClass( 'active' );
			Access.$darkmodeLabel.text( Access.darkModeTitle );
		},
		disableDarkMode : function(){
			Cookie.set( 'dark-mode', 'false' );
			Access.$sheetDarkMode.prop( 'disabled', true );
			Access.$darkmode.removeClass( 'active' );
			Access.$darkmodeLabel.text( Access.lightModeTitle );
		},

		toggleLibras : function(){
			if( Access.$toggleLibras.hasClass( 'active' ) ){
				Access.closeLibras();
			}
			else {
				Access.openLibras();			
			}
		},

		openLibras : function(){

			Access.$openLibras.trigger( 'click' );
			Access.$toggleLibras.addClass( 'active' );

			if( !Access.$closeLibras.length ){

				Access.$toggleLibras.prop( 'disabled', true );
				
				Access.waitVLibras(function(){

					Access.$toggleLibras.prop( 'disabled', false ).removeAttr( 'disabled' );
					
					// Bind close vlibras button
					Access.$closeLibras.on( 'click', function(){
						Access.$toggleLibras.removeClass( 'active' );
					});
				
				});

			}

		},

		waitVLibras : function( callback ){

			if( !Access.$closeLibras.length ){

				Access.$closeLibras = $( '.vpw-settings-btn-close' );
				if( !Access.$closeLibras.length ){
				
					if( Access.timeLibras ) clearTimeout( Access.timeLibras );
					Access.timeLibras = setTimeout(function(){
						Access.waitVLibras( callback );
					}, 300 );
				
				}
				else {
					callback();
				}
			
			}
			else {
				callback();
			}
		
		},

		closeLibras : function(){
			this.$toggleLibras.removeClass( 'active' );
			$( '.vpw-settings-btn-close' ).trigger( 'click' );
		},

		toggle : function(){
			if( this.$.hasClass( 'opened' ) ){
				this.close();
			}
			else {
				this.open();
			}
		},

		open : function(){
			this.$.addClass( 'opened' );
		},

		close :  function(){
			this.$.removeClass( 'opened' );
		}

	};

	$(function(){
		Access.init();
	});

})(jQuery);

